module.exports = __webpack_public_path__ + "img/1517674978.4e36d099.jpg";